import React from 'react';
import { toast } from 'react-toastify';
import { imprimirComprobanteMovimiento } from '../utils/impresionMovimientos';
import { imprimirReciboGrupoDual } from '../utils/comprobantePrint';
import { FormasPagoDetalleList } from './FormasPagoDetalleList';
import { esPagoCuentaCliente, etiquetaAnularPago } from '../utils/comprobantePago';

export function MovimientoDetalleModal({
  mov,
  recibo,
  reciboGrupo,
  pago,
  pagoError,
  loading,
  esProveedores,
  onClose,
  formatFecha,
  formatFechaHora,
  hasPermission,
  onAnularRecibo,
  onAnularReciboGrupo,
  onAnularPago,
  anulandoComprobante,
  logoUrl,
}) {
  if (!mov) return null;

  const fmt = (n) => parseFloat(n || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 });

  const handleImprimir = async () => {
    try {
      if (reciboGrupo) {
        imprimirReciboGrupoDual(reciboGrupo, formatFecha, logoUrl);
        return;
      }
      const ok = await imprimirComprobanteMovimiento(mov, formatFecha, logoUrl);
      if (!ok) toast.error('No se pudo imprimir el comprobante');
    } catch (e) {
      toast.error(e.message || 'Error al imprimir');
    }
  };

  const tieneFormas = (recibo?.formas_pago?.length > 0) || (pago?.formas_pago?.length > 0);
  const esperabaFormas = Boolean(recibo || pago || mov.numero_pago || mov.numero_pago_cuenta || mov.recibo_cobro_id || mov.numero_recibo);
  const tituloFormasPago = recibo
    ? 'Formas de pago del recibo'
    : esPagoCuentaCliente(pago)
      ? 'Formas de pago del pago a cuenta'
      : 'Formas de pago de la orden';
  const esPagoCuenta = esPagoCuentaCliente(pago);

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white', padding: '24px', borderRadius: '8px', maxWidth: '560px', width: '95%', maxHeight: '90vh', overflow: 'auto',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0 }}>Detalle del movimiento</h3>
          <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>×</button>
        </div>
        <table className="data-table" style={{ width: '100%', marginBottom: '16px' }}>
          <tbody>
            <tr><td style={{ fontWeight: '600', width: '140px' }}>Fecha</td><td>{formatFecha(mov.fecha)}</td></tr>
            <tr><td style={{ fontWeight: '600' }}>{esProveedores ? 'Proveedor' : 'Cliente'}</td><td>{mov.razon_social}<br /><span style={{ fontSize: '12px', color: '#7f8c8d' }}>{mov.cuit}</span></td></tr>
            <tr><td style={{ fontWeight: '600' }}>Concepto</td><td>{mov.concepto}</td></tr>
            {mov.movimiento_predefinido_descripcion && (
              <tr><td style={{ fontWeight: '600' }}>Tipo</td><td>📋 {mov.movimiento_predefinido_descripcion}</td></tr>
            )}
            <tr><td style={{ fontWeight: '600' }}>Débito / Crédito</td>
              <td>
                {mov.tipo_movimiento === 'DEBITO' ? (
                  <strong style={{ color: '#c0392b' }}>Débito ${parseFloat(mov.monto).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</strong>
                ) : (
                  <strong style={{ color: '#27ae60' }}>Crédito ${parseFloat(mov.monto).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</strong>
                )}
              </td>
            </tr>
            <tr><td style={{ fontWeight: '600' }}>Saldo acumulado</td><td><strong>${parseFloat(mov.saldo_acumulado || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</strong></td></tr>
            {mov.recibo_cobro_id && (
              <tr><td style={{ fontWeight: '600' }}>N° Recibo</td><td>{mov.numero_recibo || '-'}</td></tr>
            )}
            {mov.numero_pago && (
              <tr><td style={{ fontWeight: '600' }}>N° Orden de Pago</td><td>{mov.numero_pago}</td></tr>
            )}
            {mov.numero_pago_cuenta && (
              <tr><td style={{ fontWeight: '600' }}>N° Pago a cuenta</td><td>{mov.numero_pago_cuenta}</td></tr>
            )}
            <tr><td style={{ fontWeight: '600' }}>Usuario</td><td>{mov.usuario_nombre}</td></tr>
          </tbody>
        </table>
        {(tieneFormas || loading || pagoError || (esperabaFormas && !loading && !tieneFormas)) && !reciboGrupo && (
          <div style={{ borderTop: '1px solid #eee', paddingTop: '12px' }}>
            <FormasPagoDetalleList
              formasPago={recibo?.formas_pago || pago?.formas_pago}
              titulo={tituloFormasPago}
              loading={loading}
              error={pagoError || (!loading && esperabaFormas && !tieneFormas ? 'No se encontraron formas de pago para este comprobante' : null)}
              formatFecha={formatFecha}
            />
          </div>
        )}
        {reciboGrupo && (
          <div style={{ borderTop: '1px solid #eee', paddingTop: '12px' }}>
            <strong style={{ display: 'block', marginBottom: '8px' }}>
              Recibo de Cobro Grupo N° {reciboGrupo.numero_recibo}
              {reciboGrupo.grupo_nombre ? ` · ${reciboGrupo.grupo_nombre}` : ''}
              {' · '}
              {reciboGrupo.modo_reparto === 'orden' ? 'Reparto por orden' : 'Asignación manual'}
            </strong>
            <table className="data-table" style={{ width: '100%', marginBottom: '12px' }}>
              <thead>
                <tr><th>Cliente</th><th style={{ textAlign: 'right' }}>Asignado</th></tr>
              </thead>
              <tbody>
                {(reciboGrupo.clientes || []).map((c) => (
                  <tr key={c.id}><td>{c.razon_social}</td><td style={{ textAlign: 'right' }}>${fmt(c.monto_asignado)}</td></tr>
                ))}
              </tbody>
            </table>
            <FormasPagoDetalleList
              formasPago={reciboGrupo.formas_pago}
              titulo="Formas de pago del recibo de grupo"
              loading={loading}
              error={null}
              formatFecha={formatFecha}
            />
          </div>
        )}
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #eee' }}>
          {recibo && !recibo.anulado_at && hasPermission('anular_recibos') && onAnularRecibo && (
            <button type="button" className="btn-delete" onClick={onAnularRecibo} disabled={anulandoComprobante}>
              {anulandoComprobante ? 'Anulando...' : 'Anular recibo'}
            </button>
          )}
          {recibo?.anulado_at && (
            <span style={{ color: '#c0392b', fontWeight: 600 }}>
              Recibo anulado el {formatFechaHora(recibo.anulado_at)}
            </span>
          )}
          {pago && !pago.anulado_at && hasPermission('anular_pagos') && onAnularPago && (
            <button type="button" className="btn-delete" onClick={onAnularPago} disabled={anulandoComprobante}>
              {anulandoComprobante ? 'Anulando...' : etiquetaAnularPago(pago)}
            </button>
          )}
          {pago?.anulado_at && (
            <span style={{ color: '#c0392b', fontWeight: 600 }}>
              {esPagoCuenta ? 'Pago a cuenta anulado' : 'Orden anulada'} el {formatFechaHora(pago.anulado_at)}
            </span>
          )}
          {reciboGrupo && !reciboGrupo.anulado_at && hasPermission('anular_recibos') && onAnularReciboGrupo && (
            <button type="button" className="btn-delete" onClick={onAnularReciboGrupo} disabled={anulandoComprobante}>
              {anulandoComprobante ? 'Anulando...' : 'Anular recibo de grupo'}
            </button>
          )}
          {reciboGrupo?.anulado_at && (
            <span style={{ color: '#c0392b', fontWeight: 600 }}>
              Recibo de grupo anulado el {formatFechaHora(reciboGrupo.anulado_at)}
            </span>
          )}
          <button type="button" className="btn-primary" onClick={() => void handleImprimir()}>
            🖨️ Imprimir
          </button>
          <button type="button" className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
